module.exports = __webpack_public_path__ + "static/media/brand-icons.a1a749e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styling/theme/assets/fonts/brand-icons.svg
// module id = ./src/styling/theme/assets/fonts/brand-icons.svg
// module chunks = 0